import createModalContainer from './utils';

interface FunctionalModalProps {
  title?: string;
  message?: string;
  onOk?: (...args: any[]) => any;
  okText?: string;
}

/**
 * Confirm Modal Component in Vanilla JS
 * Functions similarly to Ant Design's Modal.confirm just without JSX
 */
const ErrorModal = ({ title, onOk, okText, message }: FunctionalModalProps) => {
  // CSS is in vl-md/src/assets/MdModal.css
  // Container
  const { dialog, closeDialog, closeButton, footer } = createModalContainer(title, message);

  // Handle OK button click
  const handleOk = async () => {
    try {
      if (!onOk) {
        closeDialog();
        return;
      }
      if (onOk.length > 0) {
        // If onOk expects a parameter, pass the close function
        await onOk(closeDialog);
      } else {
        // If onOk does not expect a parameter, call it and handle its return value
        const result = onOk();
        if (result === false) return;
        if (result instanceof Promise) {
          const resolvedResult = await result;
          if (resolvedResult === false) return; // Do not close the dialog if the promise resolves to false
        }
        closeDialog();
      }
    } catch (error) {
      console.error('Error in onOk:', error); // Handle errors in onOk
    }
  };

  dialog.addEventListener('click', (event) => {
    const rect = dialog.getBoundingClientRect();
    const isInDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!isInDialog) {
      handleOk().then(); // Execute handleCancel if the click is outside the modal
    }
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    handleOk().then();
  });

  if (closeButton) {
    closeButton.onclick = handleOk;
  }

  // OK button
  const okButton = document.createElement('button');
  okButton.textContent = okText ?? 'OK';
  okButton.className = 'md-ok ant-btn ant-btn-primary ant-btn-dangerous';
  okButton.onclick = handleOk;
  footer.appendChild(okButton);

  dialog.showModal();
};

export default ErrorModal;
